var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-booking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(-769.000000, -88.000000)",
    fill: "#3FAE29",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-filled-tool-symbol",
    transform: "translate(769.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83631963,8.50567152 C7.02694082,8.71122987 7.13159559,8.97975205 7.13159559,9.25753362 L7.13159559,17.4428304 C7.13159559,17.9354482 7.73149168,18.1854516 8.08657036,17.8391321 L10.3908441,15.2224298 C10.6992019,14.8557581 10.8692659,14.6742556 10.8692659,14.3113062 L10.8692659,9.2593855 C10.8692659,8.98160393 10.9757895,8.71308175 11.1645419,8.50750487 L17.776462,1.39816721 C18.2717034,0.864826605 17.8904797,0 17.1578776,0 L0.842946544,0 C0.110363157,0 -0.272748054,0.862974728 0.224362102,1.39816721 L6.83631963,8.50567152 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterExport);
export default __webpack_public_path__ + "static/media/filter_export.67f484188072b19231ec54f1d6d4d8ce.svg";
export { ForwardRef as ReactComponent };